// @flow
import { fetchRest } from "../rest";

export const fetchSessionInfo = async () => fetchRest("session");



// WEBPACK FOOTER //
// ./src/rest/session-context/index.js